import { render, staticRenderFns } from "./index.vue?vue&type=template&id=054211b2"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=054211b2&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('054211b2')) {
      api.createRecord('054211b2', component.options)
    } else {
      api.reload('054211b2', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=054211b2", function () {
      api.rerender('054211b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/catalog/index.vue"
export default component.exports